export default __webpack_public_path__ + "static/media/product35.ca91fccd.png";